<div class="flex flex-col items-center gap-5 py-5">
    <app-smart-dialog-result
        [loading]="service.applyLoading()"
        [error]="service.apiError()"
        [errorMessage]="service.applyErrorMessage()"
        title="Import process completed!"
        i18n-title
    ></app-smart-dialog-result>
</div>
